"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var wallet_adapter_react_1 = require("@solana/wallet-adapter-react");
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
var wallet_adapter_wallets_1 = require("@solana/wallet-adapter-wallets");
var wallet_adapter_react_ui_1 = require("@solana/wallet-adapter-react-ui");
var react_dom_1 = __importDefault(require("react-dom"));
var Wallet_1 = __importDefault(require("./Wallet"));
var TransactionButton_1 = __importDefault(require("./TransactionButton"));
var Context = function (props) {
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
    var network = wallet_adapter_base_1.WalletAdapterNetwork.Mainnet;
    // You can also provide a custom RPC endpoint.
    var endpoint = 'https://api.metaplex.solana.com/';
    // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking and lazy loading --
    // Only the wallets you configure here will be compiled into your application, and only the dependencies
    // of wallets that your users connect to will be loaded.
    var wallets = (0, react_1.useMemo)(function () { return [
        new wallet_adapter_wallets_1.PhantomWalletAdapter(),
        new wallet_adapter_wallets_1.SlopeWalletAdapter(),
        new wallet_adapter_wallets_1.SolflareWalletAdapter({ network: network }),
        new wallet_adapter_wallets_1.TorusWalletAdapter(),
        new wallet_adapter_wallets_1.LedgerWalletAdapter(),
        new wallet_adapter_wallets_1.SolletWalletAdapter({ network: network }),
        new wallet_adapter_wallets_1.SolletExtensionWalletAdapter({ network: network }),
    ]; }, [network]);
    return (react_1.default.createElement(wallet_adapter_react_1.ConnectionProvider, { endpoint: endpoint },
        react_1.default.createElement(wallet_adapter_react_1.WalletProvider, { wallets: wallets, autoConnect: true },
            react_1.default.createElement(wallet_adapter_react_ui_1.WalletModalProvider, null, props.children))));
};
exports.default = Context;
var wallet_btn = document.getElementById('wallet');
if (wallet_btn) {
    react_dom_1.default.render(react_1.default.createElement(Context, null,
        " ",
        react_1.default.createElement(Wallet_1.default, null),
        " "), wallet_btn);
}
var send_buttons = document.getElementsByClassName('nft-send-to-buyer');
if (send_buttons) {
    for (var i = 0; i < send_buttons.length; i++) {
        var send_btn = send_buttons[i];
        var dataNftId = send_btn.getAttribute("data-nft-id");
        react_dom_1.default.render(react_1.default.createElement(Context, null,
            " ",
            react_1.default.createElement(TransactionButton_1.default, { nftId: dataNftId }),
            " "), send_btn);
    }
}
